/**
 * The two languages the product speaks.
 *
 * ⚠ **French is the default, not English** (Jérémy, 17 Sep 2026). The people the report is
 * built for — Réginald, Philippe, Frédéric, Peter — work in French; English exists because
 * Hugues and the tooling do. cocon-stats, which this was ported from, hard-codes English
 * everywhere, so "the default" is a thing that has to be asserted in several places rather
 * than assumed: the database column default, the fallback when nothing is stored, and the
 * fallback when a stored value is not one we know.
 *
 * Kept in `shared` because both ends need it: the API stores the preference, the SPA
 * renders in it, and dates and numbers are formatted from it.
 */
export const LOCALES = ["fr", "en"];
/** ⚠ French. See above — this is a product decision, not a convenience. */
export const DEFAULT_LOCALE = "fr";
/** What each language calls itself. Never translated: a language picker in a language you
 *  cannot read is useless, so every option is written in its own language. */
export const LOCALE_NAMES = {
    fr: "Français",
    en: "English",
};
export function isLocale(value) {
    return typeof value === "string" && LOCALES.includes(value);
}
/**
 * Any stored or requested value → a language we actually have.
 *
 * Accepts `fr-BE`, `FR`, `en-GB` and the like, because that is what a browser sends and
 * what somebody will eventually put in the database by hand.
 */
export function asLocale(value) {
    if (!value)
        return DEFAULT_LOCALE;
    const base = value.trim().toLowerCase().split(/[-_]/)[0];
    return isLocale(base) ? base : DEFAULT_LOCALE;
}
//# sourceMappingURL=locale.js.map